import { createSlice } from "@reduxjs/toolkit";

const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem("menustate");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.log("Error loading state from sessionStorage", err);
  }
};

// Define initial state
const initialState = loadState() || {
  isMenuOpen: true, // Initial value based on your useState
  isDropdownOpen: false,
  isNestedDropdown: false,
  isStoreActive: false,
  isMobileView: false,
  isOpenedByHover: false,
  isOpenedByIcon : false
};
// Create a slice
const MenuSlice = createSlice({
  name: "menu",
  initialState,

  reducers: {
    // Reducer function for toggling menu
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    // Reducer function for setting menu state
    setMenuOpen: (state, action) => {
      state.isMenuOpen = action.payload;
      // Persist off the click path — sync sessionStorage during toggle felt heavy.
      const snapshot = { ...state };
      queueMicrotask(() => {
        try {
          sessionStorage.setItem("menustate", JSON.stringify(snapshot));
        } catch (err) {
          console.error("Error saving state to sessionStorage", err);
        }
      });
    },
    /** One-action pin/unpin for the header hamburger — avoids 4–5 cascading updates. */
    pinSidebar: (state, action) => {
      const open = Boolean(action.payload?.open);
      const isNarrow = Boolean(action.payload?.isNarrow);
      state.isMenuOpen = open;
      state.isOpenedByHover = false;
      state.isOpenedByIcon = false;
      if (!open) {
        state.isDropdownOpen = false;
      }
      // Mobile/tablet drawer visibility tracks pin; desktop stays on CSS/layout only.
      if (isNarrow) {
        state.isMobileView = open;
      }
      const snapshot = { ...state };
      queueMicrotask(() => {
        try {
          sessionStorage.setItem("menustate", JSON.stringify(snapshot));
        } catch (err) {
          console.error("Error saving state to sessionStorage", err);
        }
      });
    },
    setIsDropdownOpen: (state, action) => {
      state.isDropdownOpen = action.payload;
    },
    setNestedDropdown: (state, action) => {
      state.isNestedDropdown = action.payload;
    },
    setIsStoreActive: (state, action) => {
      state.isStoreActive = action.payload;
    },
    setIsMobileViewActive: (state, action) => {
      state.isMobileView = action.payload;
    },
    setIsOpenedByHover: (state, action) => {
      state.isOpenedByHover = action.payload;
    },
    setIsOpenedByIcon: (state, action) => {
      state.isOpenedByIcon = action.payload;
    },
  },
});

// Export actions
export const {
  toggleMenu,
  setMenuOpen,
  pinSidebar,
  setIsDropdownOpen,
  setNestedDropdown,
  setIsStoreActive,
  setIsMobileViewActive,
  setIsOpenedByHover,
  setIsOpenedByIcon,
} = MenuSlice.actions;

// Export reducer
export default MenuSlice.reducer;
